import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { werkgebiedPlaces } from '../data/werkgebied';
import { RegioMap } from './RegioMap';

// Compacte werkgebied-sectie op de homepage. Linkt naar alle plaatspagina's.
export const WerkgebiedSection: React.FC = () => {
  const main = werkgebiedPlaces.find(place => place.isMain);
  const others = werkgebiedPlaces.filter(place => !place.isMain);
  return;
};